import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.85, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ children, center = false, className = "" }) {
    return (
        <Reveal
            className={`flex items-center gap-3 ${center ? "justify-center" : ""} ${className}`}
            y={16}
        >
            <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#D4A017]" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#E88916]">
                {children}
            </span>
            <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#D4A017]" />
        </Reveal>
    );
}

export function MaskedLine({ children, delay = 0, className = "", as: Tag = "span" }) {
    return (
        <Tag className="block overflow-hidden">
            <motion.span
                className={`block ${className}`}
                initial={{ y: "112%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.9, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </Tag>
    );
}
